import { useAuth } from './hooks/useAuth'
import LoginPage from './pages/LoginPage'
import MainPage from './pages/MainPage'
import ScorePage from './pages/ScorePage'
import PolicyPage from './pages/PolicyPage'
import TermsPage from './pages/TermsPage'
import DataDeletionPage from './pages/DataDeletionPage'
import UpgradePage from './pages/UpgradePage'
import { ScoreFiltersProvider } from './context/ScoreFiltersContext'
import './styles/common/Spinner.css'

function App() {
  const { user, isAuthenticated, loading } = useAuth()
  const path = window.location.pathname
  const query = new URLSearchParams(window.location.search)
  const scoreId = query.get('scoreid')
  const isLoginPath = path === '/login'
  const isPolicyPath = path === '/policy' || path === '/privacy'
  const isTermsPath = path === '/terms'
  const isDataDeletionPath = path === '/data-deletion'
  const isUpgradePath = path === '/upgrade'
  const isComposerMode = query.get('mode') === 'compose' || path.startsWith('/guest')

  if (loading) {
    return (
      <div className="spinner-container spinner-container--screen" aria-label="Loading">
        <div className="spinner" />
      </div>
    )
  }

  if (isPolicyPath) {
    return <PolicyPage user={user} />
  }

  if (isTermsPath) {
    return <TermsPage user={user} />
  }

  if (isDataDeletionPath) {
    return <DataDeletionPage user={user} />
  }

  if (isUpgradePath) {
    if (!isAuthenticated) {
      return <LoginPage />
    }
    return (
      <ScoreFiltersProvider>
        <UpgradePage user={user} />
      </ScoreFiltersProvider>
    )
  }

  if (isLoginPath) {
    if (isAuthenticated) {
      window.location.href = '/'
      return null
    }
    return <LoginPage />
  }

  if (!isAuthenticated && !isComposerMode && !scoreId) {
    return <LoginPage />
  }

  const page = scoreId || isComposerMode ? (
    <ScorePage scoreId={scoreId} user={user} />
  ) : (
    <MainPage user={user} />
  )

  return (
    <ScoreFiltersProvider>
      {page}
    </ScoreFiltersProvider>
  )
}

export default App
